module.exports = __webpack_public_path__ + "static/media/bg.09dd8a8a.jpg";